module.exports = __webpack_public_path__ + "img/QLD-Front.245a61be.png";